import { Box, Button, CircularProgress, Container, Grid, IconButton, InputAdornment, TextField } from "@mui/material";
import unidad from "../../assets/img/unidad.png";
import { themePalette } from "../../config/theme.config";
import { useContext, useEffect, useState } from "react";
import { I18nContext } from "../../I18nProvider";
import { BarChart } from "@mui/x-charts/BarChart/BarChart";
import { InvestigadoresUnidad } from "./Unidad/InvestigadoresUnidad";

import { useLocation, useParams } from "react-router-dom";
import IresearhService from "../../services/IresearchService";
import { PubUnidadAnual } from "../../Interface/IPubUnidadAnual";
import { ProyectoUnidad } from "../../Interface/IProyectoUnidad"; 
import { ProyectoProps, Proyectos } from "./Proyecto";
import { Investigador } from "../../Interface/IInvestigadorUnidad";
import { DatosInvUnidad, DatosPubUnidad } from "../../Interface/IUnidad";
import { NotFoundPage } from "../Error/ErrorNotFound";
import { TbSearch, TbX } from "react-icons/tb";

const componentsMap: Record<"investigadores" | "proyectos", React.FC<any>> = {
    investigadores: InvestigadoresUnidad,
    proyectos: Proyectos,
};

export const Unidad: React.FC<{}> = () => {
    const context = useContext(I18nContext);
    const anio = new Date().getFullYear();
    const { nombre_unidad } = useParams<{ nombre_unidad: string }>();
    const [activeComponent, setActiveComponent] = useState<"investigadores" | "proyectos">("investigadores");
    const ActiveComponent = componentsMap[activeComponent];
    const location = useLocation();
    const [pubAnuales, setpubAnuales] = useState<PubUnidadAnual[]>([]);
    const [loadingPubAnual, setLoadingPubAnual] = useState<boolean>(true);
    const [proyAnuales, setproyAnuales] = useState<Record<string, number>>({});
    const [yearsProy, setYearsProy] = useState<string[]>([]); 
    const [valuesProy, setValuesProy] = useState<number[]>([]); 
    const [loadingProyAnual, setLoadingProyAnual] = useState<boolean>(true);
    const xAxisData = pubAnuales.map((item) => item.year);
    const seriesData = pubAnuales.map((item) => item.publications);
    const [proyectos, setProyectos] = useState<ProyectoUnidad[]>([]); 
    const [dataInvUnidad, setDataInvUnidad] = useState<DatosInvUnidad>(); 
    const [loadingdataInUnidad, setLoadingdataInUnidad] = useState<boolean>(true);
    const [dataPubUnidad, setDataPubUnidad] = useState<DatosPubUnidad>();
    const [loadingdataPubUnidad, setLoadingdataPubUnidad] = useState<boolean>(true);

    const [investigadores, setInvestigadores] = useState<Investigador[]>([]) 
    const [loadingInvestigadores, setLoadingInvestigadores] = useState<boolean>(true);
    const [totalRows, setTotalRows] = useState<number>(0);
    const [page, setPage] = useState<number>(1);

    const [notFound, setnotFound] = useState<boolean>(false);

    const [searchTerm, setSearchTerm] = useState<string>("");
    const [error, setError] = useState<boolean>(false);
    const [searchQuery, setSearchQuery] = useState<string>("");


    const [proyectosFil, setProyectosFil] = useState<ProyectoUnidad[]>([]);
    const [searchTermProy, setSearchTermProy] = useState<string>("");
    const [errorProy, setErrorProy] = useState<boolean>(false);

    const [totalPub, setTotalPub] = useState<number>(0);
    const [totalCit, setTotalCit] = useState<number>(0);

   

    if (context === null) {
        throw new Error(
            "The I18n context is not initialized. Make sure you have the provider set up correctly."
        );
    }

    const handleSearch = () => {
        if (searchTerm.length >= 4 && searchTerm.length <= 100) {
            setSearchQuery(searchTerm);
            setError(false);
        } else {
            setError(true);
        }
    };


    const handleReset = () => {
        setSearchTerm("")
        setSearchQuery("")

    }


    const normalizeText = (text: string) =>
        text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

    const handleSearchProy = () => {
        if (searchTermProy.length < 4 || searchTermProy.length > 100) {
            setErrorProy(true);
            return;
        }
        setErrorProy(false);
        const filtered = proyectos.filter((proyecto) =>
            normalizeText(proyecto.titulo).includes(normalizeText(searchTermProy))
        );
        setProyectosFil(filtered);
    };

    const handleResetProy = () => {
        setSearchTermProy("");
        setProyectosFil(proyectos);
        setErrorProy(false);
    };

    useEffect(() => {
        if (nombre_unidad) {
           
            IresearhService.GetAuthorCountByGenderAndUnit(nombre_unidad)
                .then((response) => {
                    if (!response.status.isSuccessfully) {
                        setnotFound(true);
                        return;
                    }

                    const dataUnidad: DatosInvUnidad = response.data;
                    setDataInvUnidad(dataUnidad);
                })
                .catch((error) => {
                    console.error("Error fetching user data from backend:", error);
                })
                .finally(() => {
                    setLoadingdataInUnidad(false);
                });

            IresearhService.GetTotalCitaPublicationByUnidadSaac(nombre_unidad)
                .then((response) => {
                    if (!response.status.isSuccessfully) {
                        setnotFound(true);
                        return;
                    }
                    


                    const dataUnidad: DatosPubUnidad = response.data;
                    setDataPubUnidad(dataUnidad);
                })
                .catch((error) => {
                    console.error("Error fetching user data from backend:", error);
                })
                .finally(() => {
                    setLoadingdataPubUnidad(false);
                });



            IresearhService.GetProyectosByUnidad(nombre_unidad)
                .then((proyAnual) => {
                    if (!proyAnual.status.isSuccessfully) {
                        setnotFound(true);
                        return;
                    }
                    

                    const proyList: Record<string, number> = proyAnual.data.countingsEjecutionYear;

            
                    const filteredEntries = Object.entries(proyList).filter(
                        ([year]) => {
                            const y = parseInt(year);
                            return y >= anio - 6 && y <= anio;
                        })
                    
                    const yearsArray = filteredEntries.map(([year]) => year);
                    const valuesArray = filteredEntries.map(([, value]) => value); 
                    const allProyectos: ProyectoUnidad[] = proyAnual.data.current; 
                    setproyAnuales(proyList);
                    setYearsProy(yearsArray);
                    setValuesProy(valuesArray);
                    setProyectos(allProyectos);
                    setProyectosFil(allProyectos);
                })
                .catch((error) => {
                    console.error("Error fetching user data from backend:", error);
                })
                .finally(() => {
                    setLoadingProyAnual(false); 
                });

            
            IresearhService.GetByNpubByUnidad(nombre_unidad)
                .then((pubAnual) => {
                    if (!pubAnual.status.isSuccessfully) {
                        setnotFound(true);
                        return;
                    }

                    const pubAnualesList: PubUnidadAnual[] = pubAnual.data.listData.map((item: any) => ({
                        year: item.year,
                        publications: item.publications,
                        citations: item.citations ?? 0, 
                    }));

                    
                    const sortedPubAnuales = pubAnualesList.sort((a, b) => a.year - b.year);
                    
                    setpubAnuales(sortedPubAnuales);
                    const numcit: number = pubAnual.data.totalCitations 
                    const numpub: number = pubAnual.data.totalPublications
                    setTotalCit(numcit)
                    setTotalPub(numpub)

                })
                .catch((error) => {
                    console.error("Error fetching user data from backend:", error);
                })
                .finally(() => {
                    setLoadingPubAnual(false);
                });

        } else {
            console.log("No hay nombre unidad");
        }
    }, [nombre_unidad]);


    useEffect(() => {
        if (nombre_unidad) {
            IresearhService.GetInvestigadoresByUnidad(nombre_unidad, page, searchQuery)
                .then((inv_response) => {
                    if (!inv_response.status.isSuccessfully) {
                        setnotFound(true);
                        return;
                    }
                    const allinvestigadores: Investigador[] = inv_response.data.data;
                    setTotalRows(inv_response.data.totalCount);
                    setInvestigadores(allinvestigadores);

                })
                .catch((error) => {
                    console.error("Error fetching user data from backend:", error);
                })
                .finally(() => {
                    setLoadingInvestigadores(false);
                });
        }
    }, [nombre_unidad, page, searchQuery]);



    if (notFound) {
        return (

            <NotFoundPage />

        );
    }

    return (
        <Container style={{ padding: "20px" }}>
            <Grid
                container
                direction="row"
                
                spacing={2}
                sx={{ borderBottom: `2px solid ${themePalette.NAVCOLOR}` }}
            >
                <Grid item xs={12} sm={3} md={2} sx={{ padding: "20px" }}>
                    <Box display="flex" justifyContent="center">
                        <img
                            src={unidad}
                            alt="Investigador"
                            style={{ maxWidth: "100%", height: "auto", maxHeight: "150px" }}
                        />
                    </Box>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                    <h3>{nombre_unidad!.toUpperCase()}</h3>
                    
                </Grid>
                {/*<Grid item xs={12} sm={4} md={6}>*/}
                {/*    <h3>{context.t.translate("investigador.areas")}</h3>*/}
                {/*</Grid>*/}
            </Grid>

            <Grid
                container
                direction="row"
                spacing={2}
                sx={{ borderBottom: `2px solid ${themePalette.NAVCOLOR}` }}
            >
                <Grid item xs={12} sm={3} md={4}>
                    {loadingdataInUnidad && loadingdataPubUnidad ? (
                        <CircularProgress />
                    ) : (
                        <>
                                <h3>{context.t.translate("investigador.metricas")}</h3>
                                <h3>Periodo: {anio - 6} - {anio}</h3>
                                <p><strong>{dataInvUnidad?.totalUnidad}</strong></p>
                            <p>{context.t.translate("unidad.investigadores")}</p>
                                <p><strong>{dataInvUnidad?.hombres}</strong></p>
                            <p>{context.t.translate("unidad.hombres")}</p>
                                <p><strong>{dataInvUnidad?.mujeres}</strong></p>
                                <p>{context.t.translate("unidad.mujeres")}</p>
                                <p><strong>{totalPub}</strong></p>
                                <p>{context.t.translate("investigador.publicaciones")}</p>
                                <p><strong>{totalCit}</strong></p>
                                <p>{context.t.translate("investigador.citaciones")}</p>
                        </>
                    )}
                </Grid>

                <Grid item xs={12} sm={9} md={8}>
                    <h1>{context.t.translate("home.estadisticas")}</h1>
                    <Grid container justifyContent="center" spacing={4} alignItems="center">
                        <Grid item xs={12} sm={6} md={6} sx={{ padding: "20px" }}>
                            <h4>{context.t.translate("estadisticas.proyAnuales")}</h4>
                            {loadingProyAnual ? (
                                <CircularProgress />
                            ) : (
                                <BarChart
                                    xAxis={[{ id: "anios", data: yearsProy, scaleType: "band" }]}
                                    series={[{ data: valuesProy }]}
                                    width={400}
                                    height={300}
                                />
                            )}
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} sx={{ padding: "20px" }}>
                            <h4>{context.t.translate("estadisticas.pubAnuales")}</h4>
                            {loadingPubAnual ? (
                                <CircularProgress />
                            ) : (
                                <BarChart
                                    xAxis={[{ id: "anios", data: xAxisData, scaleType: "band" }]}
                                    series={[{ data: seriesData }]}
                                    width={400}
                                    height={300}
                                />
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={2}
                sx={{ padding: "20px" }}
            >
                <Grid item xs={12} sm={2} md={2}>
                    <Button
                        fullWidth
                        onClick={() => setActiveComponent("investigadores")}
                        variant="outlined"
                        sx={{
                            color:
                                activeComponent === "investigadores"
                                    ? "white !important"
                                    : themePalette.NAVCOLOR,
                            backgroundColor:
                                activeComponent === "investigadores"
                                    ? themePalette.NAVCOLOR
                                    : "transparent",
                            borderColor: themePalette.NAVCOLOR,
                        }}
                    >
                        {context.t.translate("unidad.investigadores")}
                    </Button>
                </Grid>
                <Grid item xs={12} sm={2} md={2}>
                    <Button
                        fullWidth
                        onClick={() => setActiveComponent("proyectos")}
                        variant="outlined"
                        sx={{
                            color:
                                activeComponent === "proyectos"
                                    ? "white !important"
                                    : themePalette.NAVCOLOR,
                            backgroundColor:
                                activeComponent === "proyectos"
                                    ? themePalette.NAVCOLOR
                                    : "transparent",
                            borderColor: themePalette.NAVCOLOR,
                        }}
                    >
                        {context.t.translate("investigador.proyectos")}
                    </Button>
                </Grid>
            </Grid>

            <Box sx={{ marginTop: "20px" }}>
                {ActiveComponent && (
                    <>
                        {activeComponent === "investigadores" ? (
                            loadingInvestigadores ? (
                                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100px" }}>
                                    <CircularProgress />
                                </Box>
                            ) : (

                                    <Grid container justifyContent="center" alignItems="center" spacing={2} >

                                        <Grid item xs={12} sm={7} md={7} sx={{ marginBottom: "10px" }}>
                                            <TextField
                                                label="Búsqueda de Investigador"
                                                variant="outlined"
                                                fullWidth
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        handleSearch();
                                                    }
                                                }}
                                                error={error}
                                                helperText={error ? "El texto debe tener de 4 a 100 caracteres" : ""}
                                                InputProps={{
                                                    endAdornment: (

                                                        <InputAdornment position="end">

                                                            {searchTerm && (
                                                                <IconButton
                                                                    sx={{ color: themePalette.COLOR_SIDEBAR_ICON }}
                                                                    onClick={handleReset}
                                                                >
                                                                    <TbX />
                                                                </IconButton>
                                                            )}
                                                            
                                                            <IconButton
                                                                sx={{ color: themePalette.COLOR_SIDEBAR_ICON }}
                                                                onClick={handleSearch}
                                                            >
                                                                <TbSearch />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                    <ActiveComponent
                                        investigadores={investigadores}
                                        totalRows={totalRows}
                                        page={page}
                                        setPage={setPage}
                                        />

                                </Grid>
                            )
                        ) : activeComponent === "proyectos" ? (
                            loadingProyAnual ? (
                                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100px" }}>
                                    <CircularProgress />
                                </Box>
                                ) : (
                                        <Grid container justifyContent="center" alignItems="center" spacing={2} >

                                            <Grid item xs={12} sm={7} md={7} sx={{ marginBottom: "10px" }}>

                                                <TextField
                                                    label="Búsqueda de Proyectos"
                                                    variant="outlined"
                                                    fullWidth
                                                    value={searchTermProy}
                                                    onChange={(e) => setSearchTermProy(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            handleSearchProy();
                                                        }
                                                    }}
                                                    error={errorProy}
                                                    helperText={errorProy ? "El texto debe tener de 4 a 100 caracteres" : ""}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                {searchTermProy && (
                                                                    <IconButton
                                                                        sx={{ color: themePalette.COLOR_SIDEBAR_ICON }}
                                                                        onClick={handleResetProy}
                                                                    >
                                                                        <TbX />
                                                                    </IconButton>
                                                                )}
                                                                <IconButton
                                                                    sx={{ color: themePalette.COLOR_SIDEBAR_ICON }}
                                                                    onClick={handleSearchProy}
                                                                >
                                                                    <TbSearch />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Grid>



                                            <ActiveComponent proyectos={proyectosFil} />
                                    </Grid>
                            )
                        ) : null}
                    </>
                )}
            </Box>
        </Container>
    );
};
